export const mainPostBoxStyles = {
  w: "100%",
  maxW: "468px",
  h: "fit-content",
  borderBottom: "0.5px solid #323232",
};

export const postNavStyles = {
  p: { base: "8px 12px", md: "4px 0px" },
  align: "center",
  justifyContent: "space-between",
};

export const postThreeDot = {
  fontSize: "1.2rem",
  pr: 0,
  bg: "transparent",
  borderRadius: "40%",
  _hover: { color: "gray", bg: "transparent" },
};

export const iconPostStyles = {
  flexDir: "column",
  rowGap: "0.3rem",
  px: "3",
  pb: "2",
  pt: "2",
  p: { base: "12px 12px 0px 12px", md: "12px 0px 0px 0px" },
};

export const IconHoverStyle = {
  cursor: "pointer",
  _hover: { color: "gray" },
};

export const bookmarkPopup = {
  pos: "absolute",
  bottom: "0px",
  w: "100%",
  h: "2rem",
  align: "center",
  borderTop: "0.5px solid gray",
  borderBottom: "0.5px solid gray",
  justifyContent: "space-between",
  fontSize: "1rem",
  p: "1.5rem 1rem",
};

export const postIconStyle = {
  fontSize: "1.6rem",
  cursor: "pointer",
  _hover: { color: "gray" },
};

export const friendLikeUserStyle = {
  ml: "1",
  fontWeight: "semibold",
  align: "center",
  gap: "1",
  cursor: "pointer",
};

export const userBoldStyle = {
  fontWeight: "semibold",
  cursor: "pointer",
};

export const postContent = {
  maxW: "88%",
  overflowWrap: "break-word",
  textOverflow: "ellipsis",
};

export const captionToggleBtn = {
  variant: "link-button",
  fontSize: "0.8rem",
  p: "0",
  color: "gray",
  ml: "0.3rem",
};

export const postBoxFooterMain = {
  p: { base: "0 12px", md: 0 },
  alignItems: "center",
  pos: "relative",
  gap: "0.3rem",
};

export const postImageStyle = {
  w: "100%",
  maxH: "585px",
  minH: "400px",
  border: { base: "none", md: "0.5px solid #838383" },
  borderRadius: { base: "0", md: "6px" },
};
